import React from "react";
import "../../styles/home/TrustStats.css";

const TrustStats = () => {
  const stats = [
    {
      icon: "🚘",
      number: "Growing",
      label: "Active Listings",
      description: "New cars added regularly by verified sellers"
    },
    {
      icon: "📅",
      number: "Ongoing",
      label: "Inspections",
      description: "Inspection requests being scheduled daily"
    },
    {
      icon: "🤝",
      number: "Early",
      label: "Customer Connections",
      description: "Buyers and sellers starting to connect"
    },
    {
      icon: "📍",
      number: "5 Cities",
      label: "Service Areas",
      description: "Currently available in selected locations"
    }
  ];

  const features = [
    {
      icon: "🔍",
      title: "Inspection-first approach",
      description: "We focus on structured inspection before listing approval"
    },
    {
      icon: "📸",
      title: "Real seller uploads",
      description: "Actual car images & videos shared directly by sellers"
    },
    {
      icon: "⚡",
      title: "Simple buying flow",
      description: "Explore cars, shortlist, and book without complexity"
    },
    {
      icon: "🧾",
      title: "Clear information",
      description: "Important car details shown upfront for better decisions"
    }
  ];

  return (
    <section className="trust-section">
      <div className="container">

        {/* Header */}
        <div className="trust-header">
          <h2>A simpler way to buy & sell cars</h2>
          <p>
            We’re building a transparent platform focused on real listings,
            structured inspections, and smooth buyer-seller interactions.
          </p>
        </div>

        {/* Stats */}
        <div className="trust-stats-grid">
          {stats.map((item, index) => (
            <div key={index} className="trust-stat-card">
              <div className="icon">{item.icon}</div>
              <h3>{item.number}</h3>
              <h4>{item.label}</h4>
              <p>{item.description}</p>
            </div>
          ))}
        </div>

        {/* Features */}
        <div className="trust-features">
          <h3>Why choose us</h3>

          <div className="features-grid">
            {features.map((item, index) => (
              <div key={index} className="feature-card">
                <div className="feature-icon">{item.icon}</div>
                <div>
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default TrustStats;